/**
 * DemoShowcasePage — /demo-videos  (Sales / Demo Preview)
 *
 * Internal mockup of how the /tutorials video library looks once reframed
 * around the bring-your-own-strategy pivot (docs/DEMO_STRATEGY_VIDEO_PLAN.md).
 * Renders DemoShowcaseTree, a standalone copy of TutorialTree.jsx with
 * placeholder videos — the live /tutorials page and its data are untouched.
 */

import React, { useState } from "react";
import DemoShowcaseTree from "../../components/tutorials/DemoShowcaseTree";
import TutorialPlayer from "../../components/tutorials/TutorialPlayer";

export default function DemoShowcasePage() {
  const [playingTutorial, setPlayingTutorial] = useState(null);

  return (
    <div style={{
      minHeight: "calc(100vh - 60px)",
      background: "#f7f8fc",
      overflowY: "auto",
    }}>
      <DemoShowcaseTree onPlay={setPlayingTutorial} />

      {playingTutorial && (
        <TutorialPlayer
          tutorial={playingTutorial}
          onClose={() => setPlayingTutorial(null)}
        />
      )}
    </div>
  );
}
